import { trimJoinedStringWhitespace } from '../../core/util';

export const beneSummaryLine1 = bene => {
  const {
    name: { firstName, middleName = '', lastName },
    entityName
  } = bene;

  const fullName = [firstName, middleName, lastName].join(' ');

  return firstName ? trimJoinedStringWhitespace(fullName) : entityName;
};

export const beneSummaryLine2 = bene => {
  const { relationship, percentageDistribution } = bene;

  return [relationship, percentageDistribution]
    .filter(item => item)
    .join(' / ');
};

export const beneSummaryLine3 = bene => {
  const { taxID, dateOfBirth } = bene;

  return [taxID, dateOfBirth].filter(item => item).join(' / ');
};

export const beneRelationshipOptions = [
  'Spouse',
  'Child',
  'Parent',
  'Sibling',
  'Other'
];

export const beneInformationalText = `You may enter up to 4 primary and 4 secondary beneficiaries. 
A beneficiary may be one or more individuals or legal entities, such as a trust, estate or 
charity. This will replace any beneficiaries currently on file if you currently have a 
Rollover IRA at T. Rowe Price. A spouse is any individual who is your spouse 
under federal law. T. Rowe Price will distribute to your beneficiaries on a per capita basis. 
This means if a primary beneficiary dies before you, the percentages will be recalculated 
proportionately among the surviving primary beneficiaries. Any request to distribute the assets 
to beneficiaries on a per stirpes basis must be made in writing. Similar rules apply to secondary 
beneficiaries. Secondary beneficiaries inherit assets only if no primary beneficiaries survive you. 
You may wish to speak to an estate planner or your legal or tax professional about your personal situation.`;

export const beneCheckboxSubText = `If there are no beneficiaries on your account,
your surviving spouse will be considered sole beneficiary. If you do not have a spouse,
your estate will be considered sole beneficiary.`;

export const errorInOCRBene = (
  showPrimaryBeneRelationshipError,
  showPrimaryBeneDistributionError,
  showSecondaryBeneRelationshipError,
  showSecondaryBeneDistributionError
) => {
  return (
    showPrimaryBeneRelationshipError ||
    showPrimaryBeneDistributionError ||
    showSecondaryBeneRelationshipError ||
    showSecondaryBeneDistributionError
  );
};

export const isBeneficiariesPresent = (primaryBeneInfo, secondaryBeneInfo) => {
  return Boolean(primaryBeneInfo) || Boolean(secondaryBeneInfo);
};

export const getBeneTaxIDLabel = (entityType, enitityCategory) => {
  return entityType === enitityCategory ? 'Social Security Number' : 'Tax ID';
};

export const getOCRBeneSectionText = (iiBenes, rpsBenes) => {
  let beneSectionText = 'Beneficiary Information';
  if (iiBenes) {
    beneSectionText = 'II Beneficiary Information';
  } else if (rpsBenes) {
    beneSectionText = 'RPS Beneficiary Information';
  }
  return beneSectionText;
};
